module.exports = __webpack_public_path__ + "static/media/3.c5c17f72.png";